import React from "react";
import { formatDecimal } from "../../../util/decimalFormatter";

const tabs = [
  { key: "positions", label: "Positions" },
  { key: "orders", label: "Orders" },
  { key: "summary", label: "Account Summary" },
  { key: "logs", label: "Notification Logs" },
];

const AccountTabs = ({
  openPnl = 0,
  totalPL = 0,
  activeTab,
  onTabChange,
  positionsCount,
}) => {
  return (
    <>
    <div className="position_tab d-flex mb-1">
     
        {tabs.map((tab) => (
          <a
            href="#!"
            key={tab.key}
            className={activeTab === tab.key ? "active" : ""}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}{" "}
            <span>{tab.key === "positions" ? positionsCount : ""}</span>
          </a>
        ))} 
    </div>  
    <div className="d-flex">
    <div className="total_profit ml-auto pt-1">
        {activeTab === "positions" ? (
          <h6 className="mb-0 mr-md-2">
            Open P &amp; L:
            <span
              style={{
                color:
                  Number(openPnl) < 0 ? "rgb(242, 51, 69)" : "rgb(0, 188, 139)",
              }}
            >
              {" "}
              {formatDecimal(parseFloat(openPnl).toFixed(2), 2)}
            </span>
          </h6>
        ) : (
          <h6 className="mb-0 mr-md-2">
            Total P &amp; L:
            <span
              style={{
                color:
                  Number(totalPL) < 0 ? "rgb(242, 51, 69)" : "rgb(0, 188, 139)",
              }}
            >
              {" "}
              {formatDecimal(parseFloat(totalPL).toFixed(2), 2)}
            </span>
          </h6>
        )}
      </div>
      </div>
      </>
  );
};

export default AccountTabs;
